export async function editorialRequest(action, { method = 'GET', data, csrf, signal } = {}) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  const timeout = setTimeout(abort, 12000);
  try {
    const isFile = data instanceof FormData;
    const response = await fetch(`/news.php?action=${action}`, {
      method, credentials: 'same-origin', signal: controller.signal,
      headers: { Accept: 'application/json', ...(csrf ? { 'X-CSRF-Token': csrf } : {}), ...(data && !isFile ? { 'Content-Type': 'application/json' } : {}) },
      ...(data ? { body: isFile ? data : JSON.stringify(data) } : {}),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'No fue posible completar la operación.');
    return result;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('La solicitud tardó demasiado. Intenta nuevamente.');
    if (error instanceof SyntaxError || error instanceof TypeError) throw new Error('No pudimos conectar con el servicio editorial. Verifica que el servidor PHP esté activo.');
    throw error;
  } finally { clearTimeout(timeout); signal?.removeEventListener('abort', abort); }
}
